import React, { useContext } from 'react'
import { ContentContainer, StepHeading } from 'components/GetStarted/styles'
import PrimaryButton from 'components/generic/PrimaryButton'
import { trackClickEvent } from 'utils/Analytics'
import { Avatar, Details } from './styles'
import {
  isSubscribed,
  GET_STARTED_RETURN_URL_COOKIES_KEY,
  multipleListingsEnabled,
} from 'utils/getStartedUtils'
import Cookies from 'js-cookie'
import { AppContext } from 'contexts/AppContext'

const StepThankYou = ({ userInput, data }) => {
  const { domain } = useContext(AppContext)
  const thanksYouAvatarImgUrl = data?.site?.get_started?.thank_you_avatar?.imageUrl
  const continueUrl =
    Cookies.get(GET_STARTED_RETURN_URL_COOKIES_KEY) || data?.viewer?.user?.directory_path || '/'
  return (
    <ContentContainer>
      <StepHeading>You&apos;re All Set!</StepHeading>
      {thanksYouAvatarImgUrl && <Avatar src={thanksYouAvatarImgUrl} />}
      {isSubscribed({ userInput, data }) ? (
        <Details>
          Your payment was processed successfully!
          <br />
          We have upgraded your account to full access.
        </Details>
      ) : (
        <Details>Your basic account is ready to go!</Details>
      )}
      <PrimaryButton
        href={continueUrl}
        onClick={() => {
          trackClickEvent(domain, 'get-started-next-thank-you')
          Cookies.remove(GET_STARTED_RETURN_URL_COOKIES_KEY)
        }}
      >
        Continue
      </PrimaryButton>

      {multipleListingsEnabled({ data }) && (
        <Details>You can create more listings from your Dashboard.</Details>
      )}
    </ContentContainer>
  )
}

export default StepThankYou
